import { CacheManager } from './cache.utils';

export class AbstractCache<T> {
  // последний запрос
  protected lastRequest = '';

  // Кеш для хранения результатов запросов
  protected requestCache = new CacheManager<T>();

  /**
   * Проверка наличия данных в кеше
   */
  isCachedData(uri: string): boolean {
    return this.requestCache.has(uri);
  }

  /**
   * Очистка всего кеша
   */
  clearCache(): void {
    this.requestCache.clear();
  }

  /**
   * Установка времени жизни кеша (в миллисекундах)
   */
  setCacheTTL(milliseconds: number): void {
    this.requestCache.setTTL(milliseconds);
  }
}
